export const UPDATE_IS_API_ENABLED = 'UPDATE_IS_API_ENABLED'
export const UPDATE_FORMS = 'UPDATE_FORMS'
